<template>
    <div
            class="align-items-center"
            :class="{
            'justify-content-between': isMobile,
            'buttons-container': notSavedSearchOrMobile,
            'buttons-container d-flex justify-content-end': !isMobile,
        }"
    >
        <template v-if="isMobile">
            <div
                    class="cursor-pointer back-button mb-3"
                    @click="handleBackButtonClick"
            >
                <i
                        class="close-button far fa-arrow-left cursor-pointer mr-1"
                />
                {{ backButtonText }}
            </div>
            <div
                    v-if="showFilters"
                    class="tab-buttons-wrapper"
            >
                <div
                        v-if="!menuTabs.favoritesTab.isActive && !menuTabs.savedSearchTab.isActive"
                        class="cursor-pointer header-mobile-button ml-0 mb-2 mr-2 ml-2"
                        @click="goToTab(tabs.FAVORITE)"
                >
                    {{ menuTabs.favoritesTab.name }}
                </div>
                <div
                        v-if="!menuTabs.savedSearchTab.isActive && !menuTabs.savedSearchTab.isActive"
                        class="cursor-pointer header-mobile-button ml-0 mb-2"
                        @click="displaySavedSearches"
                >
                    {{ menuTabs.savedSearchTab.name }}
                </div>
            </div>
        </template>
        <template v-else>
            <span
                    class="header-button cursor-pointer ml-4"
                    :class="{'header-button-active': menuTabs.favoritesTab.isActive}"
                    @click="toggleFavorites"
            >
              {{ menuTabs.favoritesTab.name }}
            </span>
            <span
                    class="header-button cursor-pointer ml-4"
                    :class="{'header-button-active': menuTabs.savedSearchTab.isActive}"
                    @click="displaySavedSearches"
            >
                {{ menuTabs.savedSearchTab.name }}
            </span>
            <icon-button
                    class="help-button cursor-pointer ml-4 shadow-none"
                    @click.native="handleHelpButton"
                    v-b-tooltip.hover
                    :title="displayTooltips ? 'Help' : undefined"
                    classes="far fa-question-circle"
            />
            <span class="vertical-line d-none d-sm-block" />
            <i
                    class="close-button fal fa-times cursor-pointer"
                    @click="handleCloseButton"
            />
        </template>
    </div>
</template>

<script>
    import {debounce} from "lodash/function";
    import {
        PROPERTY_SAVED_SEARCHES_DISPLAY_MAP
    } from "../../../GroupPropertySavedSearches/PropertySavedSearches";
    import {
        PROPERTY_SAVED_SEARCH_DISPLAY
    } from "../../../GroupPropertySavedSearches/GroupPropertySavedSearchesCard/PropertySavedSearchesCard";
    import {
        PROPERTY_SEARCH_HEADER_CLEAR_LABELS,
        PROPERTY_SEARCH_MAP_DISPLAY,
        PROPERTY_SEARCH_RESET
    } from '../../../../mixins/PropertySearchMixin';
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
    import {MenuTab} from "../../../../classes/MenuTab/MenuTab";
    import PropertySearchFilters
        from "../../GroupPropertySearchFilters/PropertySearchFilters/PropertySearchFilters";
    import {GOOGLE_MAPS_MAP_MOVED} from "./../../../../components/GroupPropertySeachContent/PropertySearchMap/PropertySearchMap";
    import {proxyFilter} from "../../../../classes/Filter";
    import {FILTER_OPTIONS} from "../../../../classes/FilterDataValidations";
    import PropertySearchFilterAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/PropertySearchFilterAppResource";
    import IconButton from "./../IconButton/IconButton";

    export const PROPERTY_SEARCH_HEADER_ACCESS_HELP_CENTER = 'PropertySearchHeader:help-center';
    export const PROPERTY_SEARCH_HEADER_CLOSE_SEARCH_APP = 'PropertySearchHeader:close-search-app';
    export const PROPERTY_SEARCH_SAVED_SEARCHES_DISPLAY = 'PropertySearchHeader:saved-searches-display';
    export const PROPERTY_SEARCH_TAB_CHANGED = 'PropertySearchHeader:tab-changed';
    export const PROPERTY_SEARCH_TAB_RESET = 'PropertySearchHeader:reset-tab';

    export const TABS = {
        DEFAULT: '10',
        FAVORITE: '20',
        SAVED_SEARCH: '30',
    };

    export default {
        name: 'PropertySearchHeaderTab',
        components: {
            IconButton,
        },
        mixins: [
            IsMobileMixin,
            ShowNotificationMixin,
            PropertySearchFilters,
        ],
        props: {
            expanded: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                tabs: TABS,
                filter: proxyFilter,
                menuTabs: {
                    favoritesTab: new MenuTab('Favorites', false),
                    savedSearchTab: new MenuTab('Saved Searches', false),
                    defaultTab: new MenuTab('', true),
                },
                displaySavedSearch: false,
            };
        },
        computed: {
            backButtonText() {
                if (this.menuTabs.favoritesTab.isActive) {
                    return 'Favorites';
                }
                if (this.menuTabs.savedSearchTab.isActive) {
                    return 'Saved Searches';
                }
                if (this.$route.name === 'nearby.app.search-properties') {
                    return 'Nearby Homes';
                }

                return 'Search Properties';
            },

            notSavedSearchOrMobile() {
                return this.showFilters || !this.isMobile;
            },

            showFilters() {
                return !this.menuTabs.savedSearchTab.isActive && !this.menuTabs.favoritesTab.isActive;
            },

            tabsFocusChangeAt() {
                return this.menuTabs.favoritesTab.isActive, this.menuTabs.savedSearchTab.isActive, Date.now();
            }
        },
        /**
         *  we fetch properties in beforeMount only if we don't have default selected values for any filter
         */
        beforeMount() {
            this.$bus.$on(PROPERTY_SAVED_SEARCHES_DISPLAY_MAP, this.displayMap);
            this.$bus.$on(PROPERTY_SAVED_SEARCH_DISPLAY, this.handleDisplaySavedSearch);
            this.$bus.$on(GOOGLE_MAPS_MAP_MOVED, this.handleMapMoved);
            this.$bus.$on(PROPERTY_SEARCH_RESET, this.resetTabs);
            this.$bus.$on(PROPERTY_SEARCH_TAB_RESET, this.resetTabs);
        },

        beforeDestroy() {
            this.$bus.$off(PROPERTY_SAVED_SEARCHES_DISPLAY_MAP, this.displayMap);
            this.$bus.$off(PROPERTY_SAVED_SEARCH_DISPLAY, this.handleDisplaySavedSearch);
            this.$bus.$off(GOOGLE_MAPS_MAP_MOVED, this.handleMapMoved);
            this.$bus.$off(PROPERTY_SEARCH_RESET, this.resetTabs);
            this.$bus.$off(PROPERTY_SEARCH_TAB_RESET, this.resetTabs);
        },

        mounted() {
            if (this.$route.query && this.$route.query.savedSearchUuid) {
                return this.fetchSavedSearchFilter();
            }

            if (this.$route.query && this.$route.query.propertySearchFilter) {
                let propertySearchFilterAppResource = new PropertySearchFilterAppResource({
                    attributes: {
                        data: JSON.parse(decodeURIComponent(this.$route.query.propertySearchFilter)),
                    }
                });

                this.handleDisplaySavedSearch(propertySearchFilterAppResource);

                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        propertySearchFilter: undefined,
                    }
                });

                return;
            }

            if (this.$route.query.tab) {
                return this.goToTab(this.$route.query.tab);
            }
        },
        watch: {
            tabsFocusChangeAt: function () {
                this.relayTabFocusChangeToParent();
            },
            '$route.query': {
                deep: true,
                immediate: true,
                handler(newVal, oldVal) {
                    if (TABS.FAVORITE === newVal.tab) {
                        this.goToTab(TABS.FAVORITE);
                    }
                    if (
                        !this.displaySavedSearch && !!newVal && !!oldVal && !newVal.tab &&
                        [TABS.FAVORITE, TABS.SAVED_SEARCH].indexOf(oldVal.tab) > -1
                    ) {
                        if (
                            oldVal.tab === TABS.SAVED_SEARCH && !this.filter.favorite
                        ) {
                            this.init();
                        } else {
                            this.setFavorites(false);
                            this.resetTabs();
                        }
                    }
                }
            }
        },
        methods: {
            relayTabFocusChangeToParent: debounce(function () {
                this.$emit('PROPERTY_SEARCH_TAB_CHANGED', [
                    this.menuTabs.favoritesTab.isActive,
                    this.menuTabs.savedSearchTab.isActive
                ]);
            }, 20),
            handleBackButtonClick() {
                if (!this.menuTabs.favoritesTab.isActive && !this.menuTabs.savedSearchTab.isActive) {
                    this.handleCloseButton();
                    return;
                }
                this.resetTabs();
                this.setFavorites(false);
                this.setQueryTab(TABS.DEFAULT);
                this.$bus.$emit(PROPERTY_SEARCH_MAP_DISPLAY);
            },

            handleMapMoved() {
                this.displaySavedSearch = false;
            },

            init() {
                this.$bus.$emit(PROPERTY_SEARCH_RESET);
            },

            goToTab(tabNumber) {
                switch (tabNumber) {
                    case TABS.FAVORITE:
                        this.menuTabs.favoritesTab.isActive = false;
                        this.toggleFavorites();
                        break;
                    case TABS.SAVED_SEARCH:
                        this.displaySavedSearches();
                        break;
                    default:
                        this.init();
                }
            },

            toggleFavorites() {
                this.toggleTab(this.menuTabs.favoritesTab, PROPERTY_SEARCH_MAP_DISPLAY);
                this.checkStatusFavorites();
            },

            checkStatusFavorites() {
                this.setFavorites(this.menuTabs.favoritesTab.isActive);
                this.setQueryTab(this.menuTabs.favoritesTab.isActive ? TABS.FAVORITE : TABS.DEFAULT);
            },

            setQueryTab(tab = null) {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        tab: tab
                    }
                }).catch(() => {
                });
            },

            displaySavedSearches() {
                if (!this.menuTabs.savedSearchTab.isActive) {
                    this.menuTabs.savedSearchTab.isActive = true;
                    this.setQueryTab(TABS.SAVED_SEARCH);
                    this.changeActiveTab(this.menuTabs.savedSearchTab, PROPERTY_SEARCH_SAVED_SEARCHES_DISPLAY);
                }
            },

            displayMap() {
                this.checkStatusFavorites();
                this.changeActiveTab(this.menuTabs.defaultTab, PROPERTY_SEARCH_MAP_DISPLAY);
            },

            toggleTab(tab, event = undefined) {
                this.resetTabs(tab.name);
                tab.isActive = !tab.isActive;
                if (!!event) {
                    this.$bus.$emit(event);
                }
            },

            changeActiveTab(tab, event = undefined) {
                this.resetTabs();
                tab.isActive = true;
                this.syncExpandedPropWithParent(false);
                this.$bus.$emit(event);
            },

            resetTabs(excludedTabName = undefined) {
                for (let property in this.menuTabs) {
                    let menuTab = this.menuTabs[property];

                    if (menuTab.name === excludedTabName) continue;

                    menuTab.isActive = false;
                }
            },

            /**
             * @param value {Boolean}
             */
            setFavorites(value) {
                this.filter.favorite = value;
                this.syncExpandedPropWithParent(!value);
            },

            syncExpandedPropWithParent(isActive) {
                this.$emit('update:expanded', isActive);
            },

            handleHelpButton() {
                this.$bus.$emit(PROPERTY_SEARCH_HEADER_ACCESS_HELP_CENTER);
            },

            handleCloseButton() {
                this.$bus.$emit(PROPERTY_SEARCH_HEADER_CLOSE_SEARCH_APP);
            },

            async fetchSavedSearchFilter() {
                let propertySearchFilter = new PropertySearchFilterAppResource({uuid: this.$route.query.savedSearchUuid});
                try {
                    await propertySearchFilter.fetch();
                    this.handleDisplaySavedSearch(propertySearchFilter);

                    this.$router.push({
                        query: {
                            ...this.$route.query,
                            savedSearchUuid: undefined,
                        }
                    }).catch(() => {
                    });
                } catch (e) {
                    this.showNotification({
                        message: 'Could not load saved search. Please try again later',
                        type: 'error'
                    });
                    console.error(e);
                    this.init();
                }
            },

            handleDisplaySavedSearch(savedSearchAppResource) {
                this.displaySavedSearch = true;
                this.resetTabs();
                this.setFavorites(false);
                this.setFilters(savedSearchAppResource);
            },

            setFilters(savedSearchAppResource) {
                this.setQueryTab(TABS.DEFAULT);
                let tempFilter,
                    filters = savedSearchAppResource.data,
                    filterKeys = Object.values(FILTER_OPTIONS);
                this.$bus.$emit(PROPERTY_SEARCH_HEADER_CLEAR_LABELS);

                if (filters.hasOwnProperty('homeTypes')) {
                    filters.homeType = filters.homeTypes;
                }

                for (let key of filterKeys) {
                    if (filters.hasOwnProperty(key)) {
                        tempFilter = filters[key];

                        if (
                            key === FILTER_OPTIONS.SEARCH &&
                            filters[key].field &&
                            filters[key].label &&
                            filters[key].value
                        ) {
                            tempFilter = {
                                nested: filters[key].field,
                                value: filters[key].value,
                            };
                            this.filter.searchLabel = filters[key].label;
                        }

                        this.filter[key] = tempFilter;
                    }
                }
            },

            displayTooltips() {
                return !this.isMobile && !this.isTablet;
            },
        },
    };
</script>
